import {
  GA_MEASUREMENT_ID,
  GA_PRODUCTION_HOSTS,
  GA_SCRIPT_URL,
} from '../constants/analytics'

export function analyticsEnabled(): boolean {
  if (import.meta.env.VITE_ENABLE_GA === 'true') {
    return true
  }
  const host = window.location.hostname
  const isAllowedHost = GA_PRODUCTION_HOSTS.includes(host) || host.endsWith('.run.app')
  return import.meta.env.PROD && isAllowedHost
}

const GA_SCRIPT_ELEMENT_ID = 'ga-gtag-script'

/**
 * Loads GA4. SPA route changes are counted by GA4 enhanced measurement
 * ("page changes based on browser history events"), so no manual page_view.
 */
export function initAnalytics(): void {
  if (!analyticsEnabled()) return

  const scriptAlreadyExists = document.getElementById(GA_SCRIPT_ELEMENT_ID) !== null

  window.dataLayer = window.dataLayer ?? []

  if (typeof window.gtag !== 'function') {
    window.gtag = function gtag() {
      // gtag.js reads the raw `arguments` object, not an array copy.
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer!.push(arguments)
    }
  }

  if (!scriptAlreadyExists) {
    window.gtag('js', new Date())
    window.gtag('config', GA_MEASUREMENT_ID)

    const script = document.createElement('script')
    script.id = GA_SCRIPT_ELEMENT_ID
    script.async = true
    script.src = `${GA_SCRIPT_URL}?id=${GA_MEASUREMENT_ID}`
    document.head.appendChild(script)
  }
}

